import React from 'react'

import { BaseRow, BaseInfo, BaseAvatar } from '../BaseRow'
import { UserRowProps } from '../types'

export const UserRow = ({
  identifier,
  name,
  email,
  avatarSrc,
  role,
  inviteStatus,
}: UserRowProps) => (
  <BaseRow
    avatar={
      <BaseAvatar src={avatarSrc} name={`${name || email} avatar`}></BaseAvatar>
    }
    identifier={identifier}
    name={name}
    showStripes={false}
    pl={0}
  >
    <BaseInfo
      identifier={identifier}
      title={name}
      subtitle={email}
      inviteStatus={inviteStatus}
      role={role}
    />
  </BaseRow>
)
